import React, { useContext } from 'react';
import AuthContext from 'context/authContext';
import { useNavigate } from 'react-router-dom';
import HospitalForm from './HospitalForm';
import useUpload from 'hooks/useUpload';
import paths from 'routes/paths';
import { useCreateHospital } from 'hooks/useBeneficiaries';

function AddHospital() {
  const { organization, selectedBranchId } = useContext(AuthContext);
  const navigate = useNavigate();
  const { upload, loading: uploadLoading } = useUpload();
  const { createHospitalAsync, isCreating } = useCreateHospital();

  const submitAddHospital = async data => {
    try {
      let documentUrl = data.hospital_document;

      if (data.hospital_document && typeof data.hospital_document !== 'string') {
        documentUrl = await upload(data.hospital_document);
      }

      // Destructure to exclude form fields that need to be renamed
      const { hospitalName, contact, hospital_document, ...rest } = data;

      const hospitalData = {
        ...rest,
        name: hospitalName,
        phone: contact,
        document: documentUrl,
        organisation_id: organization.id
      };

      // Only add branch_id if it's not 'all'
      if (selectedBranchId && selectedBranchId !== 'all') {
        hospitalData.branch_id = selectedBranchId;
      }

      await createHospitalAsync(hospitalData);
      navigate(paths.hospital);
    } catch (error) {
      console.error('Error creating hospital:', error);
    }
  };

  return (
    <HospitalForm
      onSubmit={submitAddHospital}
      loading={isCreating || uploadLoading}
    />
  );
}

export default AddHospital;
